import { Loader } from '@repo/go-ui';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import { ModelsList } from 'src/features/models-list';
import { wrap } from 'src/packages/mobx-di/wrap';
import { Directories } from 'src/pages/directories';
import { DirectoryPage, Directory } from 'src/pages/directory';
import { LogoffPage } from 'src/pages/logoff/LogoffPage';

export const Router = wrap(function Router() {
  return (
    <RouterProvider
      router={createBrowserRouter(
        createRoutesFromElements(
          <>
            <Route path="/logoff" element={<LogoffPage />} />
            <Route path="/" element={<Directories />}>
              <Route path=":directory" element={<DirectoryPage />}>
                <Route index element={<Directory />} />

                <Route path=":subDirectory" element={<ModelsList />}>
                  <Route path=":modelId" element={<Directory />} />
                  <Route index element={<Loader />} />
                </Route>
              </Route>
            </Route>
          </>,
        ),
      )}
    />
  );
});
